module.exports = __webpack_public_path__ + "static/media/dots.bbf15208.svg";